<div style="width: 100%; height: 340px;" data-cy="imaging-calibration">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="imaging-calibration-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="imaging-calibration-header">
      <div class="section-header-title" data-cy="imaging-calibration-title">
        {{deviceName}} Calibration
      </div>
      <div style="flex: 1;" data-cy="imaging-calibration-header-spacer"></div>
    </div>

    @if (!isLoading) {
      <mat-grid-list cols="1" rowHeight="100%" style="height:100%;" data-cy="imaging-calibration-grid">
        <!--
        <mat-grid-tile colspan="1" >
          <mat-card appearance="outlined" style="width:100%; height:100%; display: flex; flex-direction: column;">
            <div style="width: 100%;">
              <span style="font-size: 16px;">Device: </span>
              <input matInput  placeholder="" [(ngModel)]="deviceName"  disabled="true"/>
            </div>
            &lt;!&ndash;
            <div style="flex: 1; max-height: 100%; overflow-y: hidden;">
              <app-tdo-table #deviceTable *ngIf="tableModel !== undefined"
                [tdoTableModel]="tableModel"
                (actionClick)="onTdoTableItemActionClick($event)"
              (itemSelected)="onTdoTableItemClick($event)"></app-tdo-table>
            </div>
            &ndash;&gt;
          </mat-card>
        </mat-grid-tile>
        -->
        <mat-grid-tile colspan="1" data-cy="imaging-calibration-tile">
          <mat-card appearance="outlined" style="width:100%;height:100%" data-cy="imaging-calibration-card">
            <div style="width: 100%;" data-cy="imaging-calibration-action-bar-container">
              <!--<span style="font-size: 16px;">Calibration Information </span>-->
              <app-tdo-configuration-action-bar [newHidden]="true" [saveDisabled]="editedDevices.length == 0" (newClick)="onNew($event)" (saveClick)="onSave($event)" data-cy="imaging-calibration-action-bar"></app-tdo-configuration-action-bar>
            </div>
            <mat-card-content data-cy="imaging-calibration-content">
              <div style="margin-top: 20px;" class="device-row" data-cy="imaging-calibration-ruler-row">
                <mat-form-field style="width:250px; margin-top: 6px;" data-cy="imaging-calibration-ruler-field">
                  <mat-label data-cy="imaging-calibration-ruler-label">Reference R(mm)</mat-label>
                  <input matInput placeholder="" [(ngModel)]="rulerLength"
                    (ngModelChange)="onCalibrationChange(selectedDevice)" data-cy="imaging-calibration-ruler-input" />
                  </mat-form-field>
                </div>
                <div style="margin-top: 20px;" class="device-row" data-cy="imaging-calibration-pixels-row">
                  <mat-form-field style="width:250px; margin-top: 6px;" data-cy="imaging-calibration-pixels-field">
                    <mat-label data-cy="imaging-calibration-pixels-label">Reference R(pixels)</mat-label>
                    <input disabled="true" matInput placeholder="" [(ngModel)]="sourceLength"
                      (ngModelChange)="onCalibrationChange(selectedDevice)" data-cy="imaging-calibration-pixels-input" />
                    </mat-form-field>
                  </div>
                </mat-card-content>
              </mat-card>
            </mat-grid-tile>
          </mat-grid-list>
        }

        <!--
        <div style="display: flex; flex-basis: 44px; width: 100%; padding: 2px;">
          <button (click)="cancel()" class="tdo-button primary-accent" style="margin-left: 270px; margin-right: 6px;">Cancel</button>
          <button (click)="confirm()" [disabled]="isConfirmDisabled" class="tdo-button primary-accent">Confirm</button>
        </div>
        -->


      </div>

